// extracted by mini-css-extract-plugin
var _1 = "a3GGq";
var _2 = "lZVew";
export { _1 as "base", _2 as "stats" }
